export default __webpack_public_path__ + "fonts/Gotham-Medium.78df41b8610d1ff695f5ab95ed49e177.ttf";